<template>
    <!-- <div style="border: 1px dashed green; padding: 5px; border-radius: 3px;">
        <div style="margin-bottom: 5px;">
            <div style="display: inline-block;">
                <b-badge size="sm" variant="primary" style="font-size: 15px; border: 1px solid black; background: white; color: black; padding: 7px;">TR # {{item.tr_id}}</b-badge>
            </div>
            <div style="display: inline-block;" v-if="item.invoice_id">
                <b-badge size="sm" variant="success" style="font-size: 15px; border: 1px solid dodgerblue; background: white; color: dodgerblue; padding: 7px;">INV # {{item.invoice_id}}</b-badge>
            </div>

            <div style="display: inline-block;" >
                <b-badge size="sm" variant="success" style="font-size: 15px; border: 1px solid mediumvioletred; background: white; color: mediumvioletred; padding: 7px;">Need On {{item.request_date}}</b-badge>
            </div>

            <div style="display: inline-block;">
                <div>Fulfill all from</div>
                <b-form-select 
                    size="sm" 
                    style="width: 160px;"
                    v-on:change="assign_locsub"
                >
                    <b-form-select-option v-for="locsub in packet.locsubs" :value="locsub.value">
                        
                        {{ packet.all_loc_inventory_dict[
                            JSON.stringify(item.product_id)
                            +
                            item.product_sku
                            +
                            JSON.stringify(locsub.location_id)
                            +
                            JSON.stringify(locsub.sublocation_id)
                        ]}} 

                        - 

                        {{ locsub.location }} | {{ locsub.sublocation }} 
                    </b-form-select-option>
                </b-form-select>
            </div>

            <div style="display: inline-block;">
                <div>Set Status</div>
               <b-form-select 
                    style="width: 120px;"
                    size="sm" 
                    v-on:change="assign_status"
                    :disabled="( ['admin', 'officeuser'].indexOf(packet.userDetails.userrole) > 0 || item.status > 2 )"
                >
                    <b-form-select-option v-for="st in global_vars.TRANSFER_STATUSES" :disabled="st.value > 2 || st.value == null" :value="st.value">{{st.text}}</b-form-select-option>
                </b-form-select>
            </div>

            <div style="display: inline-block;">
                <b-button size="sm" style="padding: 4px; font-size: 13px;" variant="dark" @click="updateTRItems">Update</b-button>
            </div>
        </div>
        <b-card no-body class="overflow-hidden" style="font-size: 13px;  padding: 0px; border: 0px;">
            <b-row no-gutters>
                <b-col md="3" style=" background: whitesmoke; padding: 10px; border: 1px solid crimson;">
                    <div style="font-size: 16px;"><b>{{item.product_sku}}</b></div>
                    <div style="font-size: 15px;">
                        <div>{{packet.locsubsdict[item.location_id+'|'+item.sublocation_id]}}</div>
                        <div>Created: {{item.tr_date}}</div>
                        <div>{{item.request_type}}</div>
                    </div>
                </b-col>
                <b-col style="display: inline-block;  vertical-align: top; padding: 0px; margin: 0px;">
                    <b-table-simple hover small bordered caption-top responsive style="font-size: 13px; margin-left: 5px; width: 99%; vertical-align: top;">
                        <b-thead style="background: #C5E1A5;">
                            <b-tr>
                                <b-th class="td-custom-1">SKU</b-th>
                                <b-th class="td-custom-1">Rqstd</b-th>
                                <b-th class="td-custom-1">Apprvd</b-th>
                                <b-th class="td-custom-1">Delvrd</b-th>
                                <b-th class="td-custom-1">Recvd</b-th>
                                <b-th class="td-custom-1">From</b-th>
                                <b-th class="td-custom-1">Status</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="element in item.elements" :style="{'background-color': '#fff9c4', 'border': '1px solid black'}">
                                <b-td class="td-custom-1" colspan="1">{{element.product_sku}}</b-td>
                                <b-td class="td-custom-1" colspan="1">
                                    <span v-if="['admin', 'officeuser'].indexOf(packet.userDetails.userrole) < 0">
                                        {{element.requested_quantity}}
                                    </span>
                                    <span v-else>
                                        <input v-model="element.requested_quantity" style="width: 30px;"></input>
                                    </span>
                                </b-td>
                                <b-td class="td-custom-1" colspan="1">
                                    <span v-if="['admin', 'officeuser'].indexOf(packet.userDetails.userrole) < 0">
                                        {{element.approved_quantity}}
                                    </span>
                                    <span v-else>
                                        <input v-model="element.approved_quantity" style="width: 30px;"></input>
                                    </span>
                                </b-td>
                                
                                <b-td class="td-custom-1" colspan="1">{{element.delivered_quantity}}</b-td>
                                <b-td class="td-custom-1" colspan="1">{{element.received_quantity}}</b-td>

                                <b-td class="td-custom-1">
                                    <b-form-select 
                                        v-model="element.locsub"
                                        size="sm" 
                                    >
                                        <b-form-select-option v-for="locsub in packet.locsubs" :value="locsub.value">
                                            
                                            {{ packet.all_loc_inventory_dict[
                                                JSON.stringify(element.product_id)
                                                +
                                                element.product_sku
                                                +
                                                JSON.stringify(locsub.location_id)
                                                +
                                                JSON.stringify(locsub.sublocation_id)
                                            ]}} 

                                            - 

                                            {{ locsub.location }} | {{ locsub.sublocation }} 
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-td>

                                <b-td class="td-custom-1">
                                    <b-form-select 
                                        v-model="element.status" 
                                        style="width: 120px;"
                                        size="sm" 
                                        :disabled="( ['admin', 'officeuser'].indexOf(packet.userDetails.userrole) > 0 || item.status > 2 )"
                                    >
                                        <b-form-select-option v-for="st in global_vars.TRANSFER_STATUSES" :disabled="st.value > 2 || st.value == null" :value="st.value">{{st.text}}</b-form-select-option>
                                    </b-form-select>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>

                    
                </b-col>
            </b-row>
        </b-card>
    </div> -->

    <div style="font-size: 13px; border: 1px solid forestgreen; padding: 5px;">
        <div>
            <div style="display: inline-block; width: 150px; vertical-align: top; padding: 10px;">
                <!-- <div style="">Product</div> -->
                <div style="font-size: 15px; ">{{ item.product_sku }}</div>
            </div>
            <div style="display: inline-block; width: 80px; vertical-align: top;">
                <div style="font-size: 10px;">Needed on</div>
                <div>{{ item.request_date }}</div>
            </div>

            <!-- <div style="display: inline-block; width: 80px; vertical-align: top; overflow: hidden;">
                <div style="font-size: 10px;">Type</div>
                <div>{{ item.request_type }}</div>
                <b-button size="sm" variant="dark" style="padding: 3px;" v-if="item.invoice_id">
                    {{ item.invoice_id}}
                </b-button>
            </div> -->

            <div style="display: inline-block; width: 100px; vertical-align: top;">
                <div style="font-size: 10px;">Req By</div>
                <div>{{ packet.locsubsdict[item.elements[0].location_id+'|'+item.elements[0].sublocation_id] }} </div>
            </div>


            <div style="display: inline-block; vertical-align: top;">
                <div style="display: inline-block;">
                    <div style="font-size: 10px;">Rqstd</div>
                    <input style="width: 30px; font-weight: bold; text-align: center;" disabled v-model="item.elements[0].parent_product_requested_quantity"></input>
                </div>
                <div style="display: inline-block;">
                    <div style="font-size: 10px;">Aprvd</div>
                    <input style="width: 30px; font-weight: bold; text-align: center; background: lightyellow; border: 1px solid gray;"  :disabled="packet.userDetails.userrole != 'admin'" v-model="item.elements[0].parent_product_approved_quantity"></input>
                </div>
            </div>


            <div style="display: inline-block; vertical-align: top; min-width: 100px; width: auto; margin: 10px; text-align: center;">
                <div v-if="isAllSourcesFulfilled(item.elements) == false">
                    <div style="font-size: 12px;">Assign Sources</div>
                    <div>
                        <b-form-select 
                            size="sm" 
                            style="width: 160px; font-size: 12px;"
                            v-on:change="assign_locsub"
                            :disabled="packet.userDetails.userrole != 'admin'"
                        >
                            <b-form-select-option v-for="locsub in packet.locsubs" :value="locsub.value" v-bind:key="location_id" v-if=" packet.all_loc_inventory_dict[
                                    JSON.stringify(item.product_id)
                                    +
                                    item.product_sku
                                    +
                                    JSON.stringify(locsub.location_id)
                                    +
                                    JSON.stringify(locsub.sublocation_id)
                                ]">
                                
                                {{ packet.all_loc_inventory_dict[
                                    JSON.stringify(item.product_id)
                                    +
                                    item.product_sku
                                    +
                                    JSON.stringify(locsub.location_id)
                                    +
                                    JSON.stringify(locsub.sublocation_id)
                                ]}} 

                                - 

                                {{ locsub.location }} | {{ locsub.sublocation }} 
                            </b-form-select-option>
                        </b-form-select>
                    </div>
                </div>
                <div v-else>
                    <div style="font-size: 12px;">Assigned</div>
                </div>
            </div>

            <div style="display: inline-block; vertical-align: top; text-align: center;">
                <div style="font-size: 12px;">Status</div>
                <b-form-select 
                    style="width: 120px;"
                    size="sm" 
                    v-on:change="assign_status"
                    :disabled="( ['admin', 'officeuser'].indexOf(packet.userDetails.userrole) < 0 || item.status > 2 )"
                >
                    <b-form-select-option v-for="st in global_vars.TRANSFER_STATUSES" :disabled="st.value > 2 || st.value == null" :value="st.value" v-bind:key="value">{{st.text}}</b-form-select-option>
                </b-form-select>

            </div>

            <div style="display: inline-block;">
                <b-button size="sm" variant="outline-primary" style="font-size: 13px;" @click="toggleDetails">
                    <span v-if="!show_details">Details</span>
                    <span v-else>Hide</span>
                </b-button>
            </div>

            <div style="display: inline-block;">
                <b-button size="sm" variant="outline-success" style="font-size: 13px;" @click="updateTRItems" :disabled="packet.userDetails.userrole != 'admin'">Update</b-button>
            </div>

        </div>

        <div v-if="show_details">
            <table>
                <thead>
                    <tr style="background: #f2f2f2;" >
                        <td>Product</td>
                        <td>Qty</td>
                        <td>Fulfilled From</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="element,idx in item.elements" v-bind:key="product_sku">
                        <td>{{ element.product_sku }}</td>
                        <td>{{ element.requested_quantity}}</td>
                        <td>

                            <b-form-select 
                            size="sm" 
                            style="width: 200px; font-size: 12px;"
                            v-model="element.locsub"
                            :disabled="packet.userDetails.userrole != 'admin'"    
                            >
                                <b-form-select-option v-for="locsub in packet.locsubs" :value="locsub.value" v-bind:key="location_id">
                                    {{ packet.all_loc_inventory_dict[
                                        JSON.stringify(element.product_id)
                                        +
                                        element.product_sku
                                        +
                                        JSON.stringify(locsub.location_id)
                                        +
                                        JSON.stringify(locsub.sublocation_id)
                                    ]}} 

                                    - 

                                    {{ locsub.location }} | {{ locsub.sublocation }} 
                                </b-form-select-option>
                            </b-form-select>
                        </td> 
                    </tr>
                </tbody>
            </table>

        </div>

    </div>
</template>

<script>
    import Requestor from "@/utilities/Requestor"
    export default {
        name: "TRTemplateA",
        props: ["viewdata"],
        data: function(){
            return {
                item: {},
                packet: {},
                global_vars: {},
                show_details: false
            }
        },
        methods:{
            toggleDetails: function(e){
                if (e){
                    e.preventDefault();
                }
                this.show_details = !this.show_details;
            },
            assign_locsub: function(val){
                let locsub = val;
                if (locsub) {
                    let splt = locsub.split("|");
                    if (splt.length == 2){
                        let that = this;
                        let source_location_id = +splt[0];
                        let source_sublocation_id = +splt[1];
                        this.item.elements.forEach(function(d,index){
                            that.item.elements[index].source_location_id =  source_location_id;
                            that.item.elements[index].source_sublocation_id = source_sublocation_id;
                            that.item.elements[index].locsub = locsub;
                        });
                    }
                }
            },
            assign_status: function(val){
                let status = parseInt(val);
                if (isNaN(status)){
                    this.$vex.dialog.alert({
                        message: "Invalid status assigned."
                    });
                }
                else {
                    let that = this;
                    this.item.elements.forEach(function(d,index){
                        that.item.elements[index].status =  status;
                    });
                }
            },
            updateTRItems: function(e){
                if (e){
                    e.preventDefault()
                }
                let items = this.item.elements.map(function(d) {

                    if (d.locsub){
                        let locsub = d.locsub;
                        let splt = locsub.split("|");
                        d.source_location_id = +splt[0];
                        d.source_sublocation_id = +splt[1];
                    }

                    return {
                        tr_id: d.tr_id,
                        itemid: d.itemid,
                        requested_quantity: +d.requested_quantity, 
                        approved_quantity: +d.approved_quantity, 
                        status: d.status, 
                        source_location_id: (d.source_location_id || null),
                        source_sublocation_id: (d.source_sublocation_id || null)
                    }
                });

                let path = "/api/inventory/update_tr_items/"
                let data = {"items": items};
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Updated", 
                            {title: "success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                }

                let f = function(error){
                    if (error){
                        that.$bvToast.toast(
                            "Error updating user data. Please try again.", 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                }

                Requestor.postAsyncP(path, data, this, s, f);
            },
            isAllSourcesFulfilled: function(elements){
                let all_sources_fulfilled = true;
                for (var i=0; i<elements.length; i++){
                    if (elements[i].source_location_id == null || elements[i].source_sublocation_id == null){
                        all_sources_fulfilled = false;
                        break;
                    }
                }
                return all_sources_fulfilled

            }
        },
        created: function(){
            let viewdata = this.viewdata;
            this.item = viewdata.item;
            this.packet = viewdata.packet;
            this.global_vars = viewdata.global_vars
        }
    }
</script>

<style scoped>
    .td-custom-1 {
        border: 1px solid black;
        color: black;

    }

    td {
        font-size: 13px; 
        border: 1px solid lightgray;
        padding: 3px;

    }
</style>


// WEBPACK FOOTER //
// src/components/importables/TRTemplateA.vue